/**
 * API Configuration
 * Central configuration file for all API-related settings
 */

// Get base URL based on toggle state
const getBaseUrl = (): string => {
  const useAltApi = localStorage.getItem('use_alt_api') === 'true';
  if (useAltApi) {
    return 'http://192.168.1.254';
  }
  return process.env.REACT_APP_API_URL || 'https://api-wom.whomii.com';
};

export const API_CONFIG = {
  // Base URL for API endpoints (dynamic based on toggle)
  get BASE_URL() {
    return getBaseUrl();
  },
  
  // API version
  VERSION: '', // Empty string since the API doesn't use version prefix
  
  // Timeout duration (in milliseconds)
  TIMEOUT: 30000,
  
  // Retry attempts for failed requests
  RETRY_ATTEMPTS: 3,
  
  // Retry delay (in milliseconds)
  RETRY_DELAY: 1000,
  
  // API Token for normal API (not alternative API)
  API_TOKEN: '6d2tx9Io.mUPgl27hd94dyy8kv9ueBkWd6EttNbdZ',
  
  // Token storage key (deprecated - using Basic Auth now)
  TOKEN_KEY: 'auth_token',
  
  // Refresh token storage key (deprecated - using Basic Auth now)
  REFRESH_TOKEN_KEY: 'refresh_token',
  
  // Basic Auth token storage key (base64 encoded email:password)
  BASIC_AUTH_TOKEN: 'basic_auth_token',
  
  // User data storage key
  USER_KEY: 'user',

  /**
   * Firestore REST (roadmap_analytics).
   * Override with `REACT_APP_FIRESTORE_API_KEY` in `.env.local` for a different key or stricter deploys.
   */
  FIRESTORE_PROJECT_ID: 'womgame',
  get FIRESTORE_REST_API_KEY() {
    return process.env.REACT_APP_FIRESTORE_API_KEY || 'AIzaSyDky-hH495oZfdkcVuhyONDI3vYZrh1AKI';
  },
};

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    REGISTER: '/auth/register',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
  },
  
  // User endpoints
  USERS: {
    BASE: '/users',
    BY_ID: (id: string) => `/users/${id}`,
    PROFILE: '/users/profile',
    UPDATE: '/users/update',
    DELETE: (id: string) => `/users/${id}`,
    PLAYER_ROADMAP: (playerId: string) => {
      const useAltApi = localStorage.getItem('use_alt_api') === 'true';
      if (useAltApi) {
        return `/user/player/${playerId}/roadmap/`;
      }
      return `/user/player/${playerId}/roadmap/`;
    },
  },
  
  // Dashboard endpoints
  DASHBOARD: {
    OVERVIEW: '/analytics/dashboard/overview',
    STATS: '/analytics/dashboard/stats',
    RETENTION: '/analytics/dashboard/retention/',
    METRICS: '/analytics/dashboard/metrics',
    APP_METRICS: '/analytics/dashboard/app-metrics/',
    USER_DETAILS: '/analytics/dashboard/user-details/',
    GAME_SESSION_DETAILS: '/analytics/dashboard/game-session-details/',
    CHAT_SESSION_DETAILS: '/analytics/dashboard/chat-session-details/',
    CHAT_SESSION_READ: '/analytics/dashboard/chat-session-read-chat/',
    APP_SESSION_DETAILS: '/analytics/dashboard/app-session-details/',
    TEST_SESSION_DETAILS: '/analytics/dashboard/test-session-details/',
    TABLE_COUNTS: '/analytics/dashboard/table-counts/',
    APP_ID_METRICS_DETAILS: '/analytics/dashboard/app-id-metrics-details/',
    APP_ID_METRICS_OVERVIEW: '/analytics/dashboard/app-id-metrics-overview/',
    METRICS_BY_COUNTRY: '/analytics/dashboard/metrics-by-country/',
    METRICS_BY_AGE_RANGE: '/analytics/dashboard/metrics-by-age-range/',
    GAME_TEST_RANK: '/analytics/dashboard/game-test-rank/',
    SESSION_OVERVIEWS: '/analytics/dashboard/session-overviews/',
    PROFILE_TREE: '/analytics/dashboard/profile-tree/',
    ROADMAP: '/analytics/dashboard/roadmap/',
  },
  
  // Game sessions endpoints
  GAMES: {
    BASE: '/games',
    SESSIONS: '/games/sessions',
    BY_ID: (id: string) => `/games/${id}`,
    STATS: '/games/stats',
    LEVELS: '/games/levels',
    OPENED: '/games/opened',
  },
  
  // App sessions endpoints
  SESSIONS: {
    BASE: '/sessions',
    APP: '/sessions/app',
    BY_ID: (id: string) => `/sessions/${id}`,
    STATS: '/sessions/stats',
    OPENED: '/sessions/opened',
  },
  
  // Test sessions endpoints
  TESTS: {
    BASE: '/tests',
    SESSIONS: '/tests/sessions',
    BY_ID: (id: string) => `/tests/${id}`,
    STATS: '/tests/stats',
    OPENED: '/tests/opened',
  },
  
  // Chat endpoints
  CHATS: {
    BASE: '/chats',
    THREADS: '/chats/threads',
    BY_ID: (id: string) => `/chats/${id}`,
    MESSAGES: (threadId: string) => `/chats/${threadId}/messages`,
    STATS: '/chats/stats',
    OPENED: '/chats/opened',
  },
};

export default API_CONFIG;

